import React from 'react';

interface ProgressBarProps {
  completed: number;
  total: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ completed, total }) => {
  const pct = total > 0 ? Math.min(100, (completed / total) * 100) : 0;

  return (
    <div className="eval-progress-row">
      <div className="eval-progress-bar" style={{ flex: 1 }}>
        <div className="eval-progress-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="eval-progress-text">
        {completed} / {total}
      </span>
    </div>
  );
};
